import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { useAuth } from '../context/AuthContext';
import './Footer.css';

const Footer = () => {
  const { t, imprintUrl, privacyUrl, footerCreditName, footerCreditUrl } = useLanguage();
  const { isAdmin, logout } = useAuth();
  const navigate = useNavigate();

  const handleAdminClick = () => {
    if (isAdmin) {
      navigate('/admin');
    } else {
      navigate('/admin/login');
    }
  };

  const handleAdminLogout = async () => {
    if (window.confirm(t('logout') + '?')) {
      await logout();
      navigate('/');
    }
  };

  const hasLegalLinks = Boolean(imprintUrl || privacyUrl);

  return (
    <footer className="footer">
      <div className="footer-content">
        {hasLegalLinks && (
          <nav className="footer-legal" aria-label={t('legalLinks')}>
            {imprintUrl && (
              <a
                href={imprintUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
              >
                {t('imprint')}
              </a>
            )}
            {privacyUrl && (
              <a
                href={privacyUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
              >
                {t('privacyPolicy')}
              </a>
            )}
          </nav>
        )}
        {(footerCreditName || footerCreditUrl) && (
          <p>
            {new Date().getFullYear()} - {t('developedBy')}{' '}
            {footerCreditUrl ? (
              <a
                href={footerCreditUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
              >
                {footerCreditName || footerCreditUrl}
              </a>
            ) : (
              <span>{footerCreditName}</span>
            )}
          </p>
        )}
        <div className="footer-actions">
          <button
            className="footer-admin-button"
            onClick={handleAdminClick}
          >
            {t('admin')}
          </button>
          {isAdmin && (
            <button
              className="footer-admin-button"
              onClick={handleAdminLogout}
            >
              {t('adminLogout')}
            </button>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
